import { Component } from '@angular/core';

@Component({
  selector: 'app-rfi-response',
  standalone: true,
  imports: [],
  templateUrl: './rfi-response.component.html',
  styleUrl: './rfi-response.component.css'
})
export class RfiResponseComponent {

}
